import requests from '../../../../redux/reducer/requests'
import user from '../../../../redux/reducer/user'
import content from '../../../../redux/reducer/content'
import { useDispatch } from 'react-redux'

export default function useUserCallbacks() {
  const dispatch = useDispatch()

  return {
    savePersonData: (data) => dispatch(requests.actions.savePersonData(data)),
    getAccessToken: (data) => {
      dispatch(requests.actions.savePhone(data))
      dispatch(requests.actions.savePersonData(data))
      dispatch(requests.thunks.getAccessToken(data?.phone))
    },
    setCompletedUserData: (data) => dispatch(user.actions.setCompletedUserData(data)),
    auth: () => dispatch(requests.thunks.auth()),
    generateName: () => dispatch(requests.thunks.generateName()),
    userUpdate: (data) => dispatch(requests.thunks.userUpdate(data)),
    userChange: (data) => dispatch(user.actions.change(data)),
    changeProfile: (data) => dispatch(user.actions.changeProfile(data)),
    setShareQuestId: (id) => dispatch(content.actions.setShareQuestId(id)),
    getModals: () => dispatch(requests.thunks.getModals()),
    clearDisposableModals: () => dispatch(content.actions.clearDisposableModals()),
    fromGachaToAttempts: (num) => dispatch(requests.thunks.fromGachaToAttempts(num)),
    openCustomModal: (id) => dispatch(requests.thunks.openCustomModal(id)),
    setAppInfoData: (data) => dispatch(requests.actions.setAppInfoData(data)),
    getIconsByUid: (uid) => dispatch(requests.thunks.getIconsByUid(uid)),
    markDisposableModalAsShown: (id) => dispatch(requests.thunks.markDisposableModalAsShown(id)),
    getBeautiesBalance: () => dispatch(requests.thunks.getBeautiesBalance()),
    getUserProfile: () => dispatch(requests.thunks.getUserProfile()),
    getAttempts: () => dispatch(requests.thunks.getAttempts()),
    getUserPrizes: () => dispatch(requests.thunks.getUserPrizes()),
  }
}
